import { useState, useCallback } from 'react';

interface NotificationState {
  open: boolean;
  message: string;
  severity: 'success' | 'error';
  title?: string;
}

export const useNotification = () => {
  const [notification, setNotification] = useState<NotificationState>({
    open: false,
    message: '',
    severity: 'success',
  });

  const showNotification = useCallback((message: string, severity: 'success' | 'error' = 'success', title?: string) => {
    setNotification({
      open: true,
      message,
      severity,
      title,
    });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification((prev) => ({
      ...prev,
      open: false,
    }));
  }, []);

  return {
    notification,
    showNotification,
    hideNotification,
  };
}; 